import logo from './../assets/images/logo.png';
import "../styles/components/Header.css"

/**
 * Header component for all pages.
 */
const Header = () => {
    return (
        <header>
            <div className="header-logo-container">
                <img src={logo} alt="Logo" className='header-logo-img' />
            </div>
            <h1>RIT Women in Computing Active Membership Tracker</h1>
        </header>
    );
};

export default Header;